import { createTypedSxStyles } from "@opengov/capital-mui-theme";

export const styles = createTypedSxStyles({
  centered: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    margin: "auto",
    padding: "48px 24px",
    gap: "8px",
  },
  heading: {
    fontWeight: 500,
  },
  subHeading: {
    fontWeight: 500,
  },
});
